/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcTradereportingV1Sec606AReportEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_TRADEREPORTING_V1_SEC606_A_REPORT_EVENT_ENTITY_NAME = 'ixc.tradereporting.v1.Sec606AReportEvent';
export const ixcTradereportingV1Sec606AReportEventEntity = new schema.Entity<IxcTradereportingV1Sec606AReportEvent>(IXC_TRADEREPORTING_V1_SEC606_A_REPORT_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcTradereportingV1Sec606AReportEvent) => `${entity.metadata?.eventId}` });

